// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5c9472f7","453":"bc80a12e","553":"7347c666"}[chunkId] + ".chunk.js";
};